import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '影视分类',
    links: [
      { name: '电影', path: '/category/dianying' },
      { name: '电视剧', path: '/category/dianshiju' },
      { name: '综艺', path: '/category/zongyi' },
      { name: '动漫', path: '/category/dongman' },
      { name: '纪录片', path: '/category/jilupian' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '联系方式', path: '/about#contact' },
      { name: '用户口碑', path: '/about#reputation' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { name: '流浪地球3', path: '/category/dianying' },
      { name: '繁花', path: '/category/dianshiju' },
      { name: '哪吒之魔童闹海', path: '/category/dongman' },
      { name: '狂飙', path: '/category/dianshiju' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="inline-block">
                <span className="text-2xl font-heading font-bold text-primary-400">
                  芒果视频
                </span>
              </Link>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                1080P超清画质在线观看
                <br />
                电影电视剧全集免费高清
                <br />
                流畅不卡顿，就上芒果视频
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-100 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 芒果视频 mangovideo.com 版权所有
            </p>
            <p className="text-xs text-background-500">
              本站所有资源均来自互联网，仅供学习和交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}